import React from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import Button from '../../../core-components/Button';
import styles from './RequestModal.module.scss';

export default ({ title, onConfirm, onHide, ...props }) => {
  return (
    <Modal
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      backdrop='static'
      {...props}
    >
      <Modal.Header>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <p className={styles.reqModalTitle}>{`Request Received`}</p>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12} className={styles.firstRow}>
            {`Our team will contact you shortly to help setup the integration.`}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className='mt-5'>
        <Button onClick={() => onHide()} className={styles.okBtn}>
          {'OK'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
